import UsageShow, { UsageShowProps } from '~/pages/Usage/Show';

export type PageGeneralUsageDetailsProps = UsageShowProps;

export const PageGeneralUsageDetails = ({
  id,
}: PageGeneralUsageDetailsProps) => <UsageShow id={id} />;
